const REASONS_TABLE_READY = "reasons-table-ready"
const SEARCH_TEXT_STATE = "reasons-table-search-text-state"
const ROWS_PER_PAGE_STATE = "reasons-table-rows-per-page-state"
const PAGINATION_STATE = "reasons-table-pagination-state"

const REASONS_ID_FOR_ACTION = "reasons-table-brand-id-for-action"


const ADDEDIT_REASONS_READY = "reasons-table-addedit-reasons-ready"

const initialState = {
    isReasonsTableReady: true,
    isAddEditReasonsReady: true,
    reasons: {},

    
    reasonsSelectedId: null,
    
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case REASONS_TABLE_READY:
            return Object.assign({}, state, { isReasonsTableReady: action.payload })

        case ADDEDIT_REASONS_READY:
            return Object.assign({}, state, { isAddEditReasonsReady: action.payload })

            
        
        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchFieldText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        case REASONS_ID_FOR_ACTION:
            return Object.assign({}, state, {reasonsSelectedId:action.payload})

        default:
        return state
    
    }

}

export function reasonsTableReady(data) {
    return {
        type: REASONS_TABLE_READY,
        payload: data
    }
}

export function addEditReasonsReady(data) {
    return {
        type: ADDEDIT_REASONS_READY,
        payload: data
    }
}



export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}

export function reasonsIdForAction(reasonsId){
    return{
        type:REASONS_ID_FOR_ACTION,
        payload:reasonsId
    }
}


// WEBPACK FOOTER //
// ./src/modules/Reasons/redux/reasons.js